import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import adac06941817fc40a181d55535e9d74ccb from "./generated-b04e9602-574c-462c-a0f1-0e4693ebcdb8.json";

import a29c9d22da84256b5fa5237de00994e25b from "./generated-2a02249d-ed2d-41de-8e85-2387f227c22c.json";

import adda620ef25d53c1cc04fe19e87703cc2b from "./generated-bc31a789-f313-4ad7-9a8b-4fb6b8928771.json";

import a16842bb339e574adec487357380a19d2b from "./generated-0681e116-bdfe-4ffe-aa6a-49b697b1fc4e.json";

import aeb6c07f28b335786878e192be5ab4373b from "./generated-83aa9c22-7576-4cbc-b941-910a4becc6a3.json";

import a29ab414b497a6879269afe5627502175b from "./generated-d8c649a7-b174-4da2-b8dc-8aece7e2c9c3.json";

import ac5301cd2a19d27c69bae479f3b9e91fbb from "./generated-313d0e08-4e46-4437-8999-9964ee099808.json";

import ac6eb2e083272bb72500fba6eee65f64cb from "./generated-e3ee3454-b3c2-49a4-8b48-f90c58489190.json";

import aa9cfdcd3dae13df11de78d9a2482c7afb from "./generated-f80e2b10-ce78-436c-9c6d-48ee0100a518.json";

import af248ba3df14e68cdc4c346251ccc6ab6b from "./generated-4007ffb8-4b13-4432-b691-9ee1ed769c45.json";

import ae5ae91c068a1c3d2ac7895f1cb16d6ccb from "./generated-3d7d58e7-6746-4908-acb8-0a5150f3936f.json";

import a54ef93adf306ca7a525a29d9d520d33db from "./generated-fc563257-50dd-4957-ac48-6560279d40ab.json";

import a726b72015366f9839b55a1aab483b073b from "./generated-e9a15c0b-892f-4a3c-a7d4-edfe8acd5175.json";

import add930e650ba7c2faf1331a790679471bb from "./generated-8c856c66-bcc1-4d91-88c0-5e42af544afb.json";

import a7f00d7ff68335523500132be0b0b7689b from "./generated-313cb1a1-4ae3-4968-bd46-1ea7cde3027b.json";

import a820725ace46caefa670129f836d5fa26b from "./generated-177b33f7-4afd-44e6-8895-33fb9a1370d0.json";

import a4871579e15db7a307e24cb5d217fdf55b from "./generated-e845d813-9db0-4364-b8e0-25837741b0d2.json";

import a7d1e3c8ea081a4d842c1736cdeae4442b from "./generated-39de3163-4266-4612-8aea-c6a93c0bf9fb.json";

import a1a193d69f29a919313b447ab56d1de2fb from "./generated-cbbfa3ed-30c6-440a-a4c0-11a60b45d81a.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(adac06941817fc40a181d55535e9d74ccb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a29c9d22da84256b5fa5237de00994e25b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(adda620ef25d53c1cc04fe19e87703cc2b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a16842bb339e574adec487357380a19d2b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aeb6c07f28b335786878e192be5ab4373b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a29ab414b497a6879269afe5627502175b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ac5301cd2a19d27c69bae479f3b9e91fbb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ac6eb2e083272bb72500fba6eee65f64cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(aa9cfdcd3dae13df11de78d9a2482c7afb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(af248ba3df14e68cdc4c346251ccc6ab6b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ae5ae91c068a1c3d2ac7895f1cb16d6ccb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a54ef93adf306ca7a525a29d9d520d33db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a726b72015366f9839b55a1aab483b073b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(add930e650ba7c2faf1331a790679471bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a7f00d7ff68335523500132be0b0b7689b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a820725ace46caefa670129f836d5fa26b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a4871579e15db7a307e24cb5d217fdf55b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a7d1e3c8ea081a4d842c1736cdeae4442b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a1a193d69f29a919313b447ab56d1de2fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a4871579e15db7a307e24cb5d217fdf55b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */